// Generated by CoffeeScript 1.9.1
var Colors,
  Colorscheme,
  Model,
  indexOf = [].indexOf || function (item) {
    for (var i = 0, l = this.length; i < l; i++) {
      if (i in this && this[i] === item) return i;
    }
    return -1;
  };
Colors = require("msa-colorschemes");
Model = require("backbone-thin").Model;
module.exports = Colorscheme = Model.extend({
  defaults: {
    scheme: "taylor",
    colorBackground: true,
    showLowerCase: true,
    opacity: 0.6
  },
  initialize: function initialize(data, seqs, stat) {
    this.colors = new Colors({
      seqs: seqs,
      conservation: function conservation() {
        return stat.scale(stat.conservation());
      }
    });
    return stat.on("reset", function () {
      if (this.getSelectedScheme().type === "dyn") {
        if (indexOf.call(this.getSelectedScheme(), "reset") >= 0) {
          return this.getSelectedScheme().reset();
        }
      }
    }, this);
  },
  addStaticScheme: function addStaticScheme(name, dict) {
    return this.colors.addStaticScheme(name, dict);
  },
  addDynScheme: function addDynScheme(name, fun) {
    return this.colors.addDynScheme(name, fun);
  },
  getScheme: function getScheme(name) {
    return this.colors.getScheme(name);
  },
  getSelectedScheme: function getSelectedScheme() {
    return this.colors.getScheme(this.get("scheme"));
  }
});